import { Variant } from '@kizi/core-components';

const accordionHeader: Variant = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  cursor: 'pointer',
};

const tableCells = {
  accordionHeader,
};

export default tableCells;
